var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m186.67 35c-6.1914 0-12.125 2.457-16.5 6.8359-4.375 4.375-6.8359 10.309-6.8359 16.496v443.34c0 8.3359 4.4492 16.039 11.668 20.207s16.113 4.168 23.332 0 11.668-11.871 11.668-20.207v-121.34c15.059-7.2539 31.332-11.652 47.996-12.973 27.727-1.4375 55.277 5.1758 79.332 19.039l5.0625 2.5898h0.003906c24.102 10.281 50.102 15.352 76.297 14.887 26.535 0.03125 52.852-4.8164 77.633-14.301 25.246-9.7227 48.375-24.238 68.109-42.746 8.3164-7.7891 13.059-18.66 13.113-30.055v-175.3c0.027344-11.094-4.4766-21.719-12.473-29.414-8-7.6914-18.789-11.781-29.879-11.324-22.328 0.91797-44.695 0.41797-66.965-1.4922-37.867-1.4023-75.277-8.7539-110.86-21.797l-5.25-2.5898c-29.508-16.391-63.039-24.121-96.742-22.305-15.523 1.2656-30.797 4.6836-45.383 10.148v-4.3633c0-6.1875-2.457-12.121-6.8359-16.496-4.375-4.3789-10.309-6.8359-16.496-6.8359z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFull);
export default __webpack_public_path__ + "static/media/flagFull.2c5f7452ef885768f5854d9452c2b045.svg";
export { ForwardRef as ReactComponent };